import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DashboardCard from "../../components/cards/DashboardCard";
import CustomBar from "../../components/customBar";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import { fetchDashboard } from "../../services/Dashbord";
import { constants } from "../../theme/Variables";
import PlatformChart from "./PlatformChart";

const DashboardPage = () => {
  const [dashboardData, setDashboardData] = useState(null);
  console.log(dashboardData, "dashboardDatadashboardData");
  let cartData = [
    {
      icon: APP_ICONS.userBgIcon,
      value: dashboardData?.totalUsers || 0,
      title: "App Users",
      percentage: "00.00",
    },
    {
      icon: APP_ICONS.homeBgIcon,
      value: dashboardData?.totalVendors || 0,
      title: "App Vendors",
      percentage: "00.00",
    },
    {
      icon: APP_ICONS.timerBgIcon,
      value: `$ ${dashboardData?.bbcommision?.totalCommissionAmount}` || 0,
      title: "BB Commission Earnings",
      percentage: "00.00",
    },

    {
      icon: APP_ICONS.cashHandBgIcon,
      value: `$ ${dashboardData?.customerSponseredEarnings}` || 0,
      title: "Sponsored Customer Earnings",
      percentage: "00.00",
    },
    {
      icon: APP_ICONS.cashHandBgIcon,
      value: `$ ${dashboardData?.vendorsponseredEarnings}` || 0,
      title: "Sponsored Vendors Earnings",
      percentage: "00.00",
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    handleFetchDashboardData();
  }, []);

  const handleFetchDashboardData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchDashboard();
      if (response.status === 200 || response.status === 201) {
        setDashboardData(response?.data?.data || []);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };
  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({ snackType: type, snackMessage: message });
  };
  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <CustomBar title={"DASHBOARD"} />

      {/* Dashboard Cards */}
      <Grid container spacing={2} mb={3}>
        {cartData.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <DashboardCard key={index} cardData={item} cardIndex={index} />
            </Grid>
          );
        })}
      </Grid>

      {/* Dashboard Chart */}

      <PlatformChart data={dashboardData?.revenueData || []} />
      <Loader isloading={isLoading} />
    </NavigationDrawer>
  );
};

export default DashboardPage;
